import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import './assets/css/prism.scss';
import './mixins/chartjs';
import './mixins/prismjs';
import './mock';
import { enableES5 } from 'immer';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { SettingsProvider } from './context/SettingsContext';
import { configureStore } from './store';
import { restoreSettings } from './utils/settings';
import App from './App';
import { startConsentTracking } from './utils/trackingConsent';


enableES5();

const store = configureStore();
const settings = restoreSettings();

startConsentTracking();

const container = document.getElementById('root');
const root = createRoot(container)

root.render(
	<Provider store={store}>
		<SettingsProvider settings={settings}>
			<App />
		</SettingsProvider>
	</Provider>
);

serviceWorker.unregister();
